import { Match, getWinningRosterIds } from "model/Match/Match";
import { getDefinedRosterIds } from "model/Roster/Roster";
import { Round } from "model/Tournament/Segment/RoundsSegmentGroup";

export type NonSetSwissRecord = {
  rosterId: string;
  wins: number;
  loses: number;
  matches: (Match | undefined)[];
  roundNumsLost: number[];
  position: number;
};

const createSwissRecord = (
  rosterId: string,
  numberOfRounds: number
): NonSetSwissRecord => {
  return {
    rosterId,
    wins: 0,
    loses: 0,
    matches: Array<Match | undefined>(numberOfRounds),
    roundNumsLost: [],
    position: 0,
  };
};

// todo - extract dupe code with SeasonRecord equivalent
export const calculateNonSetSwissRecords = (
  rosterIds: string[],
  rounds: Round[],
  matches: Match[]
) => {
  const records = new Map<string, NonSetSwissRecord>();
  rosterIds.forEach((id) => {
    records.set(id, createSwissRecord(id, rounds.length));
  });

  for (let i = 0; i < matches.length; i++) {
    const match = matches[i];
    const roundNum = rounds.find((r) =>
      r.matchIds.includes(match.id)
    )?.roundNum;

    if (!roundNum) {
      continue;
    }

    const winnerIds = getWinningRosterIds(match);
    if (!winnerIds) {
      continue;
    }

    const loserIds = getDefinedRosterIds(match.teams.rosters).filter(
      (id) => !winnerIds.includes(id)
    );

    winnerIds.forEach((winnerId) => {
      const winnerRecord = records.get(winnerId)!;
      winnerRecord.matches[roundNum] = match;
      winnerRecord.wins++;
    });

    loserIds.forEach((loserId) => {
      const loserRecord = records.get(loserId)!;
      loserRecord.matches[roundNum] = match;
      loserRecord.loses++;
      loserRecord.roundNumsLost.push(roundNum);
    });
  }

  const sortedRecords = Array.from(records.values()).sort(compareRecords);
  sortedRecords[0].position = 1;

  // todo - this assinging of positions is dupe code amongst the record types
  for (let i = 1; i < sortedRecords.length; i++) {
    if (compareRecords(sortedRecords[i - 1], sortedRecords[i]) === 0) {
      sortedRecords[i].position = sortedRecords[i - 1].position;
    } else {
      sortedRecords[i].position = i + 1;
    }
  }

  return sortedRecords;
};

const compareRecords = (a: NonSetSwissRecord, b: NonSetSwissRecord): number => {
  if (a.wins > b.wins) {
    return -1;
  }

  if (b.wins > a.wins) {
    return 1;
  }

  if (a.loses < b.loses) {
    return -1;
  }

  if (b.loses < a.loses) {
    return 1;
  }

  for (var i = 0; i < a.loses; i++) {
    if (a.roundNumsLost[i] > b.roundNumsLost[i]) {
      return -1;
    }

    if (b.roundNumsLost[i] > a.roundNumsLost[i]) {
      return 1;
    }
  }

  return 0;
};
